'use strict';

/**
 * @returns {Object} pageSize and categories
 */
function getPaginationDetails() {
    var pageSize = $('.grid-footer').attr('data-page-size');
    var $categories = $('.theme-grid').find('[data-subcategory-id]').toArray();
    var categories = $categories.map(function (cat) {
        return $(cat).attr('data-subcategory-id');
    });
    var count = categories.length;

    return {
        pageSize: Number(pageSize).toFixed(0),
        categories: categories,
        $categories: $categories,
        count: count
    };
}
/**
 * updates pagination details
 * @param {number} paginated items per page
 * @param {number} count  total items
 * returns undefined
 */
function updatePaginationDetails(paginated, count) {
    var percentage = paginated * 100 / count;
    $('.theme-grid #current-pagination').text(paginated);
    $('.theme-grid .progress-bar').css('width', percentage.toFixed(0) + '%');
}

// Display the first {pageSize} elements of the categories on first page
$(document).ready(function () {
    var pagination = getPaginationDetails();
    var pageSize = pagination.pageSize;
    var paginated = pageSize;

    if (pagination.categories.length <= pageSize) {
        $('.plp-theme-more-button-wrapper button').addClass('d-none');
        paginated = pagination.count;
    }

    pagination.categories.forEach(function (cat, index) {
        if (index + 1 > pageSize) {
            $('.container')
                .find("[data-subcategory-id='" + cat + "']").parent().hide();
        }
    });

    updatePaginationDetails(paginated, pagination.count);
});

/**
 * front end implementation of show more categories button
 * It will display the hidden categories on show more button click
 * returns undefined
 */
function showMoreCategories() {
    $('.theme-grid').on(
        'click',
        '.plp-theme-more-button-wrapper button',
        function (e) {
            e.preventDefault();
            e.stopPropagation();
            var pagination = getPaginationDetails();

            var hiddenCategories = pagination.$categories.filter(function (element) {
                return $(element).parent().is(':hidden');
            });

            // display show less on first click of show more
            var showLessButton = $('.show-less-button-wrapper').find(
                'button'
            );
            showLessButton.removeClass('d-none');

            // display the rest of the items and hide show more button on last page
            if (hiddenCategories.length <= pagination.pageSize) {
                $(this).addClass('d-none');
                $(hiddenCategories).each(function (index, element) {
                    $(element).parent().show();
                });
            } else {
                $(hiddenCategories).each(function (idx, el) {
                    if (idx + 1 > pagination.pageSize) {
                        $(el).parent().hide();
                    } else {
                        $(el).parent().show();
                    }
                });
            }
            var paginated = $('.theme-grid').find('[data-subcategory-id]:visible').length;
            updatePaginationDetails(paginated, pagination.count);
        }
    );
}

/**
 * front end implementation of show less categories button
 * It will hide the displayed of n categories per page on show less button click
 * returns undefined
 */
function showLessCategories() {
    $('.show-less-button-wrapper').on('click', 'button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if ($('.theme-grid').length > 0) {
            var pagination = getPaginationDetails();
            var paginated = $('.theme-grid').find('[data-subcategory-id]:visible');
            var totalPages = Math.ceil(pagination.count / pagination.pageSize);

            // find the n elements from the last page and hide them
            if (paginated.length === pagination.count) {
                var start = (totalPages * pagination.pageSize) - (pagination.pageSize - 1);
                var itemsOnLastPage = pagination.count - (start - 1);

                paginated.slice(-itemsOnLastPage).parent().hide();
            } else {
                $(paginated).slice(-pagination.pageSize).parent().hide();
            }

            var current = $('.theme-grid').find('[data-subcategory-id]:visible').length;
            // hide show less button on first page
            if (current <= pagination.pageSize) {
                $('.plp-theme-more-button-wrapper button').removeClass('d-none');
                $(this).addClass('d-none');
            }

            updatePaginationDetails(current, pagination.count);
        }
    });
}

module.exports = {
    showMoreCategories: showMoreCategories,
    showLessCategories: showLessCategories,
    updatePaginationDetails: updatePaginationDetails
};
